import {
  Component,
  Inject,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Input,
  AfterViewInit, AfterViewChecked, OnDestroy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjektState } from '../../../projektverwaltung/store/reducer/projektverwaltung.reducer';
import { NodeItem } from '../../../projektverwaltung/node.model';
import { State } from '../../../landingpage/store/reducer/landingpage.reducer';
import {loadUserNodesStart} from '../../../projektverwaltung/store/actions/getUserNodes.actions';
import {loadProjektSelectboxStart} from '../../../Zeiterfassung/store/actions/project-selectbox.actions';
import {AuswertungState} from '../../store/reducer/auswertungen.reducer';

export interface DialogData{
  id: number;
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'auswertungen-stufen',
  templateUrl: './auswertungen-stufen.component.html',
  styleUrls: ['./auswertungen-stufen.component.scss'],
})

/*
* selector: 'app-zeiterfassung-baum',
  templateUrl: './zeiterfassung-stufen.component.html',
  styleUrls: ['./zeiterfassung-stufen.component.scss'],
* */

export class AuswertungenStufenComponent implements OnInit, OnDestroy {
  $nodes;
  arrOpen = [];
  disabled: boolean;

  @Input()
  selectboxItems: NodeItem[] = [];

  @Input()
  public set disablen(disablen: boolean) {
    this.disabled = disablen;
  }

  constructor(
    public dialogRef: MatDialogRef<AuswertungenStufenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private store: Store<{landingpage: State}>,
    public auswertungen: Store<{ auswertungen: AuswertungState }>,
  public projektverwaltung: Store<{ projektverwaltung: ProjektState }>
  ) {
    if(sessionStorage.getItem('rolleId') === '3' || (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null)){
      this.$nodes = projektverwaltung.pipe(select((state) => state.projektverwaltung.usernodes.items));
    }
    else{
      this.$nodes = auswertungen.pipe(select((state) => state.auswertungen.selectboxProjekte));
    }
   // this.$nodes = zeiterfassung.pipe(select((state) => state.zeiterfassung.selectboxProjekte));
  }


  public addButtonForm = new FormGroup({
    color: new FormControl(''),
    projektstufe0: new FormControl('', [Validators.required]),
    showStufe0: new FormControl(true),
    projektstufe1: new FormControl(''),
    letzteProjektstufe: new FormControl(''),
    id: new FormControl(''),
  });

  public handleSubmitClick(): void{
    const item = this.addButtonForm.value;
    /*console.log(item);*/
    if (this.data.id) {

    } else {
      /*this.store.dispatch(addDashboardStart({item}));*/
    }
    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public loadProjektstufe(projekt: NodeItem): void {
    if ( projekt === undefined){
      return;
    }
    // tslint:disable-next-line:radix
    this.addButtonForm.addControl('projektstufe' + ( parseInt(projekt.level) + 1) , new FormControl(''));
    this.addButtonForm.addControl('showStufe' + ( parseInt(projekt.level) + 1) , new FormControl(true));
   // this.zeit.dispatch(loadProjektSelectboxStart({projektId: projekt.id}));
    // console.log(projekt);
    // arrOpen leeren bis zu dem Punkt wo wir das neue Projekt abspeichern.
    // ( Bei einem Projekt von Level 1 wird alles ausser die 0te Stelle des Arrays gelöscht/weggeschnitten )
    this.arrOpen.splice(parseInt(projekt.level));
    // Einfügen des Projektes an Obersten Stelle des Arrays falls das Projekt noch Kinder hat.
    // Wenn das nicht der Fall ist wird NULL eingefügt.
    // die rechte Seite des Codes auf der nächsten Linie bedeutet: Falls projekt keine Kinder hat dann: null Sonst: projekt
    this.arrOpen[projekt.level] = !projekt.children[0]?.name ? null : projekt;
  }

  ngOnInit(): void {
    this.store.dispatch(loadUserNodesStart());
  }

  ngOnDestroy(): void {
    this.store.dispatch(loadProjektSelectboxStart({projektId: 0}));
//    console.clear();
  }

  public compareFunction(projekt1: NodeItem, projekt2: NodeItem): boolean{
    return projekt1 && projekt2 && projekt1.id === projekt2.id;
}


public convertStringToInt(projektLevel: string): number{
  // tslint:disable-next-line:radix
    return parseInt(projektLevel);
}

}

